import ErrorSecurity from "./Error.jsx";

export default ErrorSecurity;
